import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Badge } from '@components'
import type { ContainerPayingProps } from './Container.types'
import { useFormatCurrency } from './Container.hooks'

const ContainerPaying: React.FC<ContainerPayingProps> = ({
    name,
    description,
    point,
    currency,
    amount,
    LayoutRightComponent,
}) => {
    const { t } = useTranslation()

    const { currencySymbol, formattedAmount, formattedPoint } =
        useFormatCurrency(amount, point, currency)

    return (
        <div className="flex items-center justify-between border-b border-semantic-background-secondary px-6 py-7 lg:px-8">
            <div className="space-y-1">
                <h4 className="text-body-lg-b text-semantic-content-ink">
                    {name}
                </h4>
                <p className="text-body-sm-r text-semantic-content-inkMedium">
                    {description}
                </p>
            </div>
            <div className="flex flex-col items-end gap-1">
                {LayoutRightComponent && LayoutRightComponent}
                {!LayoutRightComponent && (
                    <React.Fragment>
                        <p className="text-display-md-b text-semantic-content-ink">{`${currencySymbol}${formattedAmount}`}</p>
                        <Badge
                            as="span"
                            children={`${t('@deposit.EarnablePoint.point_label')}: ${currencySymbol}${formattedPoint}`}
                            variant="yellow"
                            size="tiny"
                            className="w-fit"
                        />
                    </React.Fragment>
                )}
            </div>
        </div>
    )
}

export default ContainerPaying
